import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../pages/pages-shared.module';
import {CategoryListModalComponent} from './category-list-modal.component';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        CategoryListModalComponent
    ],
    entryComponents: [
        CategoryListModalComponent
    ],
    exports: [
        CategoryListModalComponent
    ]
})
export class CategoryListModalModule {
}
